import { render, staticRenderFns } from "./almere.vue?vue&type=template&id=349f32b3"
import script from "./almere.vue?vue&type=script&lang=js"
export * from "./almere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports